<h3>{{'change.createIndex.create' | translate}}</h3>
<div class="ps-flex-container-col">
  <mat-form-field>
    <input matInput placeholder="Index" [(ngModel)]="index"/>
  </mat-form-field>

  <div>
    <button mat-button (click)="cancel()">{{'change.createIndex.discard' | translate}}</button>
    <button mat-button (click)="save()">{{'change.createIndex.save' | translate}}</button>
  </div>
</div>
